<script lang="ts">
	//Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
	import { devices_config } from 'src/configs/devices';
	//Components
	import ControlOnOffAmbient from 'src/components/Controls/Single/ControlOnOffAmbient.svelte';
	import ControlCuryIntensity from 'src/components/Controls/Single/ControlCuryIntensity.svelte';
	import ControlCuryAwayMode from 'src/components/Controls/Single/ControlCuryAwayMode.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device;

	const deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: isSidePanelOpen = $showNewLayout;

	// Status and label processing
	$: _statuses = status?.online && deviceConfig ? status_configurator(status, device, settings) : [];
	$: labelList = Array.isArray(_statuses)
		? _statuses.filter((e) => {
				return 'undefined' === typeof e.main && e.name !== 'state';
			})
		: [];

	let timerLabels: Record<string, any> = {};
	$: combinedLabelList = [...Object.values(timerLabels), ...labelList];
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		<DeviceLabelList labelList={combinedLabelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom">
		<ControlOnOffAmbient {device} {status} {settings} {isSidePanelOpen} />
		<ControlCuryIntensity {device} {status} {isSidePanelOpen} />
		<ControlCuryAwayMode {device} {status} {isSidePanelOpen} />
	</div>
</DeviceViewStateWrapper>
